<template>
  <div class="reactions">
    <div class="button-like" @click="checkLikes"><span class="button-like__icon"></span><span
        class="button-like__count">{{ reactionsData().likes }}</span></div>
    <div class="button-like" @click="checkDislikes"><span class="button-dislike__icon"></span><span
        class="button-like__count">{{ reactionsData().dislikes }}</span></div>
  </div>
</template>

<script>
export default {
  name : "Reactions",
  props: {
    reactions: Object,
    user    : {
      type   : Object,
      require: true
    },
  },
  data() {
    return {}
  },
  methods: {
    toggleLike   : function () {
      let responseData = this.reactionsData();

      responseData.liked = !responseData.liked;

      responseData.liked ? responseData.likes++ : responseData.likes--;
    },
    toggleDislike: function () {
      let responseData = this.reactionsData();

      responseData.disliked = !responseData.disliked;

      responseData.disliked ? responseData.dislikes++ : responseData.dislikes--;
    },
    showAuth(){
      $('#f__auth').modal('show');
    },
    checkLikes() {
      if(!this.user.authorizedUser){
        this.showAuth();
        return;
      }
      const responseData = Object.assign({}, this.reactionsData());

      if (responseData.disliked) {
        // убрать дизлайк
        this.toggleDislike();
        // добавить лайк
        this.toggleLike();
      } else {
        // добавить лайк
        this.toggleLike();
      }

      this.$emit('updateReactions', {...this.reactionsData(), old: {...responseData}})
    },
    checkDislikes() {
      if(!this.user.authorizedUser){
        this.showAuth();
        return;
      }
      const oldData = Object.assign({}, this.reactionsData());
      let responseData = this.reactionsData();

      if (responseData.liked) {
        // убрать лайк
        this.toggleLike();
        // добавить дизлайк
        this.toggleDislike();
      } else {
        // добавить дизлайк
        this.toggleDislike();
      }

      this.$emit('updateReactions', {...this.reactionsData(), old: {...oldData}})
    },
    reactionsData() {
      return this.$parent.reactions();
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>